// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4b4d6c33","787":"0a134047"}[chunkId] + ".chunk.js";
};